import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { CalendarIcon, UsersIcon, BuildingIcon, ClockIcon, ShieldCheckIcon } from 'lucide-react';
interface StatItem {
  icon: React.ReactNode;
  value: number;
  suffix: string;
  label: string;
}
const stats: StatItem[] = [{
  icon: <CalendarIcon className="w-6 h-6" data-id="element-8" />,
  value: 12,
  suffix: '+',
  label: 'Років на ринку'
}, {
  icon: <UsersIcon className="w-6 h-6" data-id="element-9" />,
  value: 3500,
  suffix: '+',
  label: 'Закритих вакансій'
}, {
  icon: <BuildingIcon className="w-6 h-6" data-id="element-10" />,
  value: 500,
  suffix: '+',
  label: 'Клієнтів'
}, {
  icon: <ClockIcon className="w-6 h-6" data-id="element-11" />,
  value: 14,
  suffix: ' днів',
  label: 'Середній термін закриття'
}, {
  icon: <ShieldCheckIcon className="w-6 h-6" data-id="element-12" />,
  value: 90,
  suffix: ' днів',
  label: 'Гарантійний період'
}];
function AnimatedCounter({
  target,
  suffix,
  inView
}: {
  target: number;
  suffix: string;
  inView: boolean;
}) {
  const [count, setCount] = useState(0);
  const hasAnimated = useRef(false);
  useEffect(() => {
    if (!inView || hasAnimated.current) return;
    hasAnimated.current = true;
    const duration = 1800;
    const startTime = performance.now();
    function animate(currentTime: number) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setCount(Math.round(eased * target));
      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    }
    requestAnimationFrame(animate);
  }, [inView, target]);
  return <span data-id="element-13">
      {count.toLocaleString('uk-UA')}
      {suffix}
    </span>;
}
export function AchievementsSection() {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section className="relative py-16 bg-white" id="about" data-id="element-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" ref={ref} data-id="element-15">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 lg:gap-6" data-id="element-16">
          {stats.map((stat, index) => <motion.div key={stat.label} initial={{
          opacity: 0,
          y: 24
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="relative p-6 rounded-2xl bg-navy-50/60 border border-navy-100 text-center group" data-id="element-17">
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-primary-100 text-primary-600 mb-4" data-id="element-18">
                {stat.icon}
              </div>
              <div className="text-3xl lg:text-4xl font-extrabold text-navy-900 tracking-tight" data-id="element-19">
                <AnimatedCounter target={stat.value} suffix={stat.suffix} inView={isInView} data-id="element-20" />
              </div>
              <div className="mt-1 text-sm text-navy-500 font-medium" data-id="element-21">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}